import { gql } from "@apollo/client"

export const GET_SHARED_PLAN_BY_ID = gql`
  query getSharedPlanById($id: Int!, $resolution: String!, $fromTimeStamp: DateTime!, $toTimeStamp: DateTime!) {
    sharedPlan(apiPlanId: $id) {
      id
      start
      end
      totalUsageMetrics(resolution: $resolution, fromTimeStamp: $fromTimeStamp, toTimeStamp: $toTimeStamp) {
        allUsages {
          timeStamp
          mbCount
        }
        terminalPieStats {
          terminalSerialNumber
          terminalNickname
          totalUsageAggregated
          percentage
        }
      }
      organization {
        id
      }
    }
  }
`
